export default __webpack_public_path__ + "media/images/landing-20-550x420-5895861c7b13392ef4727dfb305c03f7.jpg";